import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";

var _templateObject;

var _excluded = ["className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Carousel, DESKTOP_DRAWER_WIDTH, MOBILE_DRAWER_WIDTH, Tooltip as MuiTooltip } from '@infl-ts/ui-advocate-components';
import { profile456 } from '@infl-ts/util-advocate-mocks';
import { makeDecodeError } from '@infl-ts/util-make-apollo-decoded';
import { logQueryError } from '@infl-ts/util-query-errors';
import { Stage } from '@infl-ts/util-use-challenge-player';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import { Box, styled, tooltipClasses, Typography } from '@mui/material';
import * as DE from '@nll/datum/lib/DatumEither';
import clsx from 'clsx';
import * as E from 'fp-ts/Either';
import { flow, pipe } from 'fp-ts/function';
import { useStyles } from 'tss-react';
import CurrentStage from '../challenge-player/stages/index';
import ChallengeHeader from './challenge-header';
import FirstStageInfo from './first-stage-info';
import StageError from './stage-error';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var Tooltip = styled(function (_ref) {
  var _props$classes, _props$classes2;

  var className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(MuiTooltip, _objectSpread(_objectSpread({}, props), {}, {
    classes: _objectSpread(_objectSpread({}, (_props$classes = props.classes) !== null && _props$classes !== void 0 ? _props$classes : {}), {}, {
      popper: clsx(className, (_props$classes2 = props.classes) === null || _props$classes2 === void 0 ? void 0 : _props$classes2.popper)
    })
  }));
})(function (_ref2) {
  var theme = _ref2.theme;
  return _defineProperty({}, "& .".concat(tooltipClasses.tooltip), {
    backgroundColor: theme.palette.neutral.dark
  });
});
var Circle = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background-color: ", ";\n  width: 56px;\n  height: 56px;\n\n  &:hover {\n    background-color: ", ";\n  }\n"])), function (p) {
  return p.theme.palette.action.focus;
}, function (p) {
  return p.theme.palette.action.focus;
});

var completeStage = function completeStage(_options) {
  return new Promise(function (resolve) {
    return resolve(E.left({
      _tag: 'decoding',
      errors: []
    }));
  });
};

var Preview = function Preview(_ref4) {
  var _stages, _stages2;

  var challenge = _ref4.challenge,
      stages = _ref4.stages,
      stageIndex = _ref4.stageIndex,
      setStageIndex = _ref4.setStageIndex,
      _ref4$skippableOnboar = _ref4.skippableOnboarding,
      skippableOnboarding = _ref4$skippableOnboar === void 0 ? false : _ref4$skippableOnboar;

  var _useStyles = useStyles(),
      css = _useStyles.css;

  var currentStage = stages[stageIndex % stages.length];
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ChallengeHeader, {
      headline: challenge.headline,
      stageIndex: stageIndex,
      totalStages: stages.length,
      skippableOnboarding: skippableOnboarding,
      "data-element": "ChallengeHeader",
      "data-component": "Preview",
      "data-source-file": "preview.tsx"
    }), /*#__PURE__*/_jsx(Box, {
      sx: {
        display: 'flex',
        width: 1,
        minHeight: {
          xs: 'calc(100% - 120px)',
          md: 'calc(100% - 68px)'
        }
      },
      "data-element": "Box",
      "data-source-file": "preview.tsx",
      children: /*#__PURE__*/_jsxs(Box, {
        sx: [{
          transition: function transition(theme) {
            return theme.transitions.create(['width'], {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.enteringScreen
            });
          },
          width: '100%',
          flexGrow: 1
        }, {
          display: 'flex',
          flexDirection: 'column',
          width: {
            md: "calc(100% - ".concat(MOBILE_DRAWER_WIDTH, "px)"),
            lg: "calc(100% - ".concat(DESKTOP_DRAWER_WIDTH, "px)")
          },
          overflow: 'scroll',
          transition: function transition(theme) {
            return theme.transitions.create(['width'], {
              easing: theme.transitions.easing.easeOut,
              duration: theme.transitions.duration.enteringScreen
            });
          }
        }],
        "data-element": "Box",
        "data-source-file": "preview.tsx",
        children: [/*#__PURE__*/_jsx(Box, {
          sx: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: 1,
            px: 3
          },
          "data-element": "Box",
          "data-source-file": "preview.tsx",
          children: currentStage && /*#__PURE__*/_jsxs(Typography, {
            sx: {
              py: 1.5,
              mr: 'auto',
              color: function color(t) {
                return t.palette.text.secondary;
              }
            },
            variant: "body2",
            children: [stageIndex + 1, "/", stages.length, /*#__PURE__*/_jsx(Box, {
              component: "span",
              sx: {
                ml: 2
              },
              children: currentStage.name
            })]
          })
        }), /*#__PURE__*/_jsx(Carousel, {
          autoPlay: false,
          indicators: false,
          animation: "slide",
          cycleNavigation: false,
          navButtonsAlwaysVisible: true,
          timeout: 0,
          className: css({
            flex: 1,
            overflow: 'visible'
          }),
          index: stageIndex % stages.length,
          onChange: setStageIndex,
          navButtonsWrapperProps: {
            className: css({
              '&:hover button': {
                filter: 'none !important',
                opacity: '1 !important'
              }
            }),
            style: {
              top: -7,
              marginLeft: 41,
              marginRight: 41
            }
          },
          navButtonsProps: {
            className: css({
              position: 'sticky',
              top: '50%',
              '&:hover': {
                opacity: '1 !important'
              }
            }),
            style: {
              padding: 0,
              background: 'none'
            }
          },
          PrevIcon: /*#__PURE__*/_jsx(Tooltip, {
            placement: "right",
            title: "Stage ".concat(stageIndex, ": ").concat((_stages = stages[stageIndex - 1]) === null || _stages === void 0 ? void 0 : _stages.name),
            children: /*#__PURE__*/_jsx(Circle, {
              children: /*#__PURE__*/_jsx(ChevronLeft, {
                sx: function sx(theme) {
                  return {
                    fontSize: theme.typography.h2.fontSize,
                    fill: theme.palette.common.black
                  };
                }
              })
            })
          }),
          NextIcon: /*#__PURE__*/_jsx(Tooltip, {
            placement: "left",
            title: "Stage ".concat(stageIndex + 2, ": ").concat((_stages2 = stages[stageIndex + 1]) === null || _stages2 === void 0 ? void 0 : _stages2.name),
            children: /*#__PURE__*/_jsx(Circle, {
              children: /*#__PURE__*/_jsx(ChevronRight, {
                sx: function sx(theme) {
                  return {
                    fontSize: theme.typography.h2.fontSize,
                    fill: theme.palette.common.black
                  };
                }
              })
            })
          }),
          "data-element": "Carousel",
          "data-source-file": "preview.tsx",
          children: stages.map(function (stage) {
            return /*#__PURE__*/_jsxs(Box, {
              sx: {
                mx: 'auto',
                px: 2.5,
                maxWidth: 860,
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column'
              },
              children: [stageIndex === 0 ? /*#__PURE__*/_jsx(FirstStageInfo, {
                challenge: challenge
              }) : null, pipe(Stage.decode(_objectSpread(_objectSpread({}, stage), {}, {
                publicResponses: null
              })), E.match(flow(makeDecodeError, logQueryError, function () {
                return /*#__PURE__*/_jsx(StageError, {});
              }), function (stage) {
                return /*#__PURE__*/_jsx(CurrentStage, {
                  stage: stage,
                  completeStage: completeStage,
                  completeStageStatus: DE.pending,
                  profile: profile456,
                  isOnboarding: false,
                  isPreview: true,
                  prospect: challenge.prospect
                });
              }))]
            }, stage.id);
          })
        })]
      })
    })]
  });
};

export default Preview;